var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.37 16.3297L14.8906 14.8548M17.0904 9.52455C17.0904 12.2128 15.6523 14.6968 13.3178 16.041C10.9833 17.3852 8.10712 17.3852 5.77259 16.041C3.4381 14.6969 2 12.2129 2 9.52455C2 6.83632 3.4381 4.35227 5.77259 3.00808C8.10709 1.66397 10.9833 1.66397 13.3178 3.00808C15.6523 4.35224 17.0904 6.83648 17.0904 9.52455ZM21.6251 19.8227L18.1509 16.3582C17.6513 15.8598 16.8409 15.8598 16.3413 16.3582C15.8416 16.8566 15.8416 17.6646 16.3413 18.163L19.8155 21.6276C20.3151 22.126 21.1255 22.126 21.6251 21.6276C22.1249 21.1289 22.1249 20.3208 21.6251 19.8227Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9d4e051714b2f946c9466a0d8a23da64.svg";
export { ForwardRef as ReactComponent };